// @ts-strict-ignore
import CardTitle from "@dashboard/components/CardTitle";
import { Timeline, TimelineNote } from "@dashboard/components/Timeline";
import { CustomerDetailsQuery } from "@dashboard/graphql";
import { Card, CardContent, Typography } from "@material-ui/core";
import React from "react";
import { defineMessages, useIntl } from "react-intl";

const messages = defineMessages({
  title: {
    id: "vErDaH01",
    defaultMessage: "Activity log",
    description: "customer history card title",
  },
  noEvents: {
    id: "vErDaH02",
    defaultMessage: "No activity recorded yet.",
    description: "customer history empty state",
  },
});

export interface CustomerHistoryProps {
  events: CustomerDetailsQuery["user"]["events"];
}

// Fallback label for system events that carry no `message` (e.g. ACCOUNT_CREATED).
const humanizeType = (type: string) =>
  type ? type.replace(/_/g, " ").toLowerCase() : "";

const CustomerHistory: React.FC<CustomerHistoryProps> = ({ events }) => {
  const intl = useIntl();
  // Newest first.
  const items = (events ?? []).slice().reverse();

  return (
    <Card>
      <CardTitle title={intl.formatMessage(messages.title)} />
      <CardContent>
        {items.length === 0 ? (
          <Typography variant="caption">
            {intl.formatMessage(messages.noEvents)}
          </Typography>
        ) : (
          <Timeline>
            {items.map(event => (
              <TimelineNote
                key={event.id}
                date={event.date}
                user={event.user}
                message={event.message || humanizeType(event.type)}
                hasPlainDate
              />
            ))}
          </Timeline>
        )}
      </CardContent>
    </Card>
  );
};

CustomerHistory.displayName = "CustomerHistory";
export default CustomerHistory;
